exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-icon-full-screen[data-v-29234bee] {\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  /* fill: #5a5e66;; */\r\n  fill:#671E75;\r\n  width: 20px;\r\n  height: 20px;\r\n  font-size: 20px;\n}\r\n", ""]);

// exports
